import type { ReactNode } from "react";
import { CustomLevelsContext, useCustomLevelsState } from "#custom-levels-context";

export function CustomLevelsProvider({ children }: { children: ReactNode }) {
  const value = useCustomLevelsState();
  return <CustomLevelsContext value={value}>{children}</CustomLevelsContext>;
}
